export const state = {
  message: "Initial message",
};
